/**
 * useUxBehavior — mounts the always-learning UX behavior tracker (#589).
 *
 * Install ONCE near the app root (AppShell). It:
 *   - installs the global click / back-navigation listeners
 *     (initUxBehaviorTracking), and
 *   - emits a `ux.behavior.nav` transition on every route change so the
 *     nightly review can reconstruct navigation funnels + clicks-to-goal.
 *
 * Fire-and-forget; never affects rendering or UX.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initUxBehaviorTracking, noteNavigation } from "@/lib/uxBehavior";

export function useUxBehavior(): void {
  const location = useLocation();

  // Install global listeners once.
  useEffect(() => {
    const cleanup = initUxBehaviorTracking();
    return cleanup;
  }, []);

  // Emit a navigation transition whenever the path changes.
  useEffect(() => {
    noteNavigation(location.pathname);
  }, [location.pathname]);
}
